/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6a9e6648"]'><div :class='["mt-20","toast-with-self-defined-icon-demo"]'><cube-button @_click="clickToast">Toast - use system icon</cube-button><cube-toast txt="预约暂不支持多车型，部分车型无法预约" icon="delete" ref="__mpx_ref_toast__"></cube-toast><cube-button @_click="clickToast('img')" :class='["mt-20"]'>Toast - use image icon</cube-button><cube-toast txt="请输入乘车人手机号" ref="__mpx_ref_toastImg__"><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/c40384a2-25ef-4781-8e08-44447823d861.png" mode="aspectFit" :class='["custom-img"]'></mpx-image></cube-toast></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_6a9e6648"}'>
.mt-20
  .cube-btn
    margin-top 20px
.custom-img
  width 30px
  height 30px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6a9e6648"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6a9e6648"}
  /** script content **/
  require("./toast-with-self-defined-icon.mpx.js?isComponent&outputPath=components%2Ftoast-with-self-defined-icon6a9e6648%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./toast-with-self-defined-icon.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftoast-with-self-defined-icon6a9e6648%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6a9e6648"],
    ctorType: "component",
    outputPath: "components/toast-with-self-defined-icon6a9e6648/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-toast':getComponent(require("../../../packages/mpx-cube-ui/src/components/toast/index.mpx?isComponent&outputPath=components%2Findex7b472558%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>